export default ({ store, redirect }) => {
  if (store.state.intro.intro) {
    // return redirect('/auth/login')
    return redirect('/')
  }
}
